import '../braft/index.css'
import React from 'react'
import BraftEditor from 'braft-editor'

// 引入表情包组件样式文件
//import '../braft/emoticon.css'

// 引入表情包组件和默认表情包列表
// import Emoticon, { defaultEmoticons } from 'braft-extensions/dist/emoticon'
//
// // 转换默认表情包列表，让webpack可以正确加载到默认表情包中的图片，请确保已对png格式的文件配置了loader
// const emoticons = defaultEmoticons.map(item => require(`braft-extensions/dist/assets/${item}`))

// 也可以使用自己的表情包资源
// const emoticons = ['http://path/to/emoticon-1.png', 'http://path/to/emoticon-2.png', 'http://path/to/emoticon-3.png', 'http://path/to/emoticon-4.png', ...]
//
// BraftEditor.use(Emoticon({
//     //includeEditors: ['demo-editor-with-emoticon'],
//     excludeControls:['line-height','letter-spacing','superscript','subscript','remove-styles','text-align','text-indent','headings','list-ul','list-ol'],
//     emoticons: emoticons
// }))

export default class EmoticonDemo extends React.Component {

    render () {
        const controls = ['bold','italic','emoji']
        return (
            <div style={{border:"1px solid #dfdfdf", borderLeft:"none",fontSize:12}}>
                <BraftEditor controls={controls} placeholder="输入内容" onSave={this.props.cc} value={this.props.vv.editorState} onChange={this.props.change} contentStyle={{width:260,height:60}} style={{width:260,height:90}} />
            </div>
        )

    }

}